/* tslint:disable */
/* eslint-disable */
/**
 * HAU.ITDE.SpareParts.Purchase.NonShop.Portal.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProblemDetails } from '../model';
// @ts-ignore
import type { ProductInfoModelShort } from '../model';
/**
 * SniApi - axios parameter creator
 * @export
 */
export const SniApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return article data
         * @param {string} serialnumber 
         * @param {string} [cultureInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SniArticledataSerialnumberGet: async (serialnumber: string, cultureInfo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serialnumber' is not null or undefined
            assertParamExists('v1SniArticledataSerialnumberGet', 'serialnumber', serialnumber)
            const localVarPath = `/v1/sni/articledata/{serialnumber}`
                .replace(`{${"serialnumber"}}`, encodeURIComponent(String(serialnumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cultureInfo !== undefined) {
                localVarQueryParameter['cultureInfo'] = cultureInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SniApi - functional programming interface
 * @export
 */
export const SniApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SniApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return article data
         * @param {string} serialnumber 
         * @param {string} [cultureInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1SniArticledataSerialnumberGet(serialnumber: string, cultureInfo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductInfoModelShort>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1SniArticledataSerialnumberGet(serialnumber, cultureInfo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SniApi.v1SniArticledataSerialnumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SniApi - factory interface
 * @export
 */
export const SniApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SniApiFp(configuration)
    return {
        /**
         * 
         * @summary Return article data
         * @param {string} serialnumber 
         * @param {string} [cultureInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SniArticledataSerialnumberGet(serialnumber: string, cultureInfo?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductInfoModelShort> {
            return localVarFp.v1SniArticledataSerialnumberGet(serialnumber, cultureInfo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SniApi - interface
 * @export
 * @interface SniApi
 */
export interface SniApiInterface {
    /**
     * 
     * @summary Return article data
     * @param {string} serialnumber 
     * @param {string} [cultureInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SniApiInterface
     */
    v1SniArticledataSerialnumberGet(serialnumber: string, cultureInfo?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductInfoModelShort>;

}

/**
 * SniApi - object-oriented interface
 * @export
 * @class SniApi
 * @extends {BaseAPI}
 */
export class SniApi extends BaseAPI implements SniApiInterface {
    /**
     * 
     * @summary Return article data
     * @param {string} serialnumber 
     * @param {string} [cultureInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SniApi
     */
    public v1SniArticledataSerialnumberGet(serialnumber: string, cultureInfo?: string, options?: RawAxiosRequestConfig) {
        return SniApiFp(this.configuration).v1SniArticledataSerialnumberGet(serialnumber, cultureInfo, options).then((request) => request(this.axios, this.basePath));
    }
}

